import { UAParser } from "ua-parser-js";

export function getMobileOS(): "Android" | "iOS" | "Other" {
    // Possible 'os.name's: https://github.com/faisalman/ua-parser-js/tree/1.0.38#documentation
    const os = UAParser(navigator.userAgent).os.name;
    switch (os) {
        case "Android":
            return os;
        case "iOS":
            return os;
        default:
            return "Other";
    }
}

/**
 * An iPad whose Safari is in desktop mode (the iPadOS default since 13), which sends a plain `Macintosh`
 * user agent. No Mac has a touchscreen, so a `Macintosh` user agent with touch points is an iPad.
 */
export function isIPadInDesktopMode(): boolean {
    if (typeof navigator === "undefined") {
        return false;
    }

    return /Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1;
}

/**
 * Whether the user agent is a phone or a tablet, or neither. Says nothing about whether it is a webview.
 * ua-parser cannot see an iPad in desktop mode, so that case is added on top of its result.
 */
export function getMobileDeviceType(): "mobile" | "tablet" | undefined {
    if (typeof navigator === "undefined") {
        return undefined;
    }

    const deviceType = UAParser(navigator.userAgent).device.type;
    if (deviceType === "mobile" || deviceType === "tablet") {
        return deviceType;
    }

    return isIPadInDesktopMode() ? "tablet" : undefined;
}

/**
 * Any Android WebView: our app's, or another app's in-app browser. Android puts a `wv` token in every
 * WebView's user agent; Chrome, Samsung Internet and Edge on Android do not carry it.
 *
 * A regex until we upgrade to ua-parser-js 2.x, which reports these as `browser.type === "inapp"`.
 * 1.x only names the browser, and names Facebook, Instagram and LinkedIn's WebViews after the app, so
 * a browser-name check misses them. 2.x is AGPL-3.0 (1.x is MIT), so the upgrade needs a licence decision.
 */
export function isAndroidWebView(): boolean {
    if (typeof navigator === "undefined") {
        return false;
    }

    return /; wv\)/.test(navigator.userAgent);
}
